import { render, staticRenderFns } from "./AddNotificationModalComponent.vue?vue&type=template&id=50e3fc9b"
import script from "./AddNotificationModalComponent.vue?vue&type=script&lang=js"
export * from "./AddNotificationModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports